import { TimePicker } from "@mui/x-date-pickers"
import { SchedulerTimeInput } from "generated/graphql"

export type Props = {
	size?: "medium" | "small"
	fieldIsChanged?: boolean
	disabled?: boolean
	fullWidth?: boolean
	required?: boolean
	value?: SchedulerTimeInput | null
	error?: boolean
	helperText?: string | null
	label?: string
	onChange: (date: SchedulerTimeInput | null) => void
}

export default function TimeInput({
	size = "medium",
	fullWidth = true,
	required = false,
	fieldIsChanged,
	disabled = false,
	label,
	onChange,
	value,
	error,
	helperText,
}: Props) {
	const handleChange = (date: Date | null) => {
		if (!date || isNaN(date?.getTime() ?? 0)) {
			onChange(null)
			return
		}
		onChange({ hour: date.getHours(), minute: date.getMinutes() })
	}

	return (
		<TimePicker
			format="HH:mm"
			ampm={false}
			label={label}
			value={value ? new Date(2025, 1, 1, value.hour ?? 0, value.minute ?? 0) : null}
			disabled={disabled}
			slotProps={{
				textField: {
					error,
					helperText,
					required,
					margin: "normal",
					fullWidth: fullWidth,
					size: size,
					color: fieldIsChanged ? "secondary" : undefined,
				},
			}}
			onChange={handleChange}
		/>
	)
}
